module.exports = __webpack_public_path__ + "img/instrument.a1a76312.svg";